import React from "react";
import LoginForm from "../auth/LoginForm";
const Login=()=>{
  return(
          <div>
            <LoginForm/>
          </div>

   )
}
export default Login;